import { newYearData } from '../lib/data';
import styles from './NewYear.module.scss';


const NewYear = () => {
    return ( 
        <section >
            <div className = {styles.container}> 
                {newYearData.map(({id, photo}) => (
                    <div className = {styles.container__photo} key={id}> 
                    <img  className={styles.photo} src={photo} alt="новогодняя фотосессия Ставрополь"/>
                    </div>
                ))}                
            </div>
        </section>
     );
}
 
export default NewYear;